module.exports = __webpack_public_path__ + "static/img/6.b011abc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/6.png
// module id = WJlU
// module chunks = 0